<template>

    <div class="user_wbox">
        <div class="inter">
            <div class="div1 t-flex">
                <div class="fl">

                    <usermenu></usermenu>
                </div>
                <div class="fr">

                    <div class="user_center" style="width: 100%;">

                        <div class="user_de_ti" style="margin-bottom: 30px;">资金明细</div>

                        
                        <div class="money_user">
                            <div class="text_1">
                                <p class="p1">账户余额</p>
                                <p class="p2">{{ userinfo.money }}</p>
                            </div>
                            <div class="text_2">
                                <div class="sp1" @click="$router.push('/withdraw')">立即提现</div> 
                            </div>
                        </div>


                        <div class="money_log">
                            <div class="item" v-for="(item, index) in list">
                                <div class="text_1">
                                    <p class="p1">{{ item.memo }}</p>
                                    <p class="p2">{{ item.createtime }}</p>
                                </div>
                                <div class="text_2">
                                    <span class="sp1" v-if="parseFloat(item.money) > 0">+{{ item.money }}</span>
                                    <span class="sp2" v-if="parseFloat(item.money) <= 0">{{ item.money }}</span>
                                </div>
                            </div>

                        </div>


                        <el-empty description="暂无数据" v-if="list.length == 0"></el-empty>

                        <el-pagination class="pagebox" v-if="list.length > 0 && !isMobile" background
                            @size-change="handleSizeChange" @current-change="handleCurrentChange"
                            :current-page="current_page" :page-sizes="[10, 20, 30, 40, 50]" :page-size="10"
                            layout="total, sizes, prev, pager, next, jumper" :total="total">
                        </el-pagination>
                        <el-pagination class="pagebox" v-if="list.length > 0 && isMobile" background
                            @size-change="handleSizeChange" @current-change="handleCurrentChange"
                            :current-page="current_page" :page-sizes="[10, 20, 30, 40, 50]" :page-size="10"
                            layout="total, prev, pager, next" :total="total">
                        </el-pagination>


                    </div>
                </div>
            </div>
        </div>
    </div>

</template>


<script>
import usermenu from '@/components/dialogs/usermenu'
import {
    Notification,
    Message
} from 'element-ui'
import moment from 'moment';
export default {
    components: {
        usermenu

    },
    data() {
        return {
            list: [],
            current_page: 1,
            pagesize: 10,
            total: 0,
            last_page: 0,

            info: {},
            loading: false


        }
    },
    computed: {
        userinfo() {
            return this.$store.getters.userinfo
        }
    },
    created: function (data) {
        this.$store.dispatch('getUserinfo')
        this.current_page = 1;
        this.pagesize = 10;
        this.addRandomData(this.current_page);

    },
    watch: {
        $route() {

        }
    },
    methods: {

        handleSizeChange(val) {

            this.pagesize = val;
            this.addRandomData(this.current_page);
        },
        handleCurrentChange(val) {
            this.current_page = val;
            this.addRandomData(this.current_page);
        },

        addRandomData(current_page) {
            this.loading = true;
            var that = this;
            this.list = []




            this.rq.requests.post("api/game/user/money_log", {
                page: current_page,
                pagesize: that.pagesize,
            }).then(res => {
                that.last_page = res.data.last_page;
                that.current_page = res.data.current_page;
                that.total = res.data.total;
                that.list = res.data.data;
                that.loading = false
            }).catch(error => {

            })
        },



    }


}
</script>